/**
 * The reasons a creator (or their agent) can give for turning a mission
 * down — the id is what the list selects on, the title is what gets stored
 * on the deal memo's note.
 */
export const OUTREACH_DECLINE_REASONS = [
  { id: "dates", title: "Not available on the dates" },
  { id: "busy", title: "Schedule is too busy to fit this in" },
  { id: "brand", title: "Don't want to work with this brand" },
  { id: "exclusivity", title: "Have exclusivity with a competitor" },
  { id: "no-deals", title: "Not doing brand deals right now" },
  { id: "other", title: "Something else" },
] as const;

export const getDeclineReasonTitles = (ids: string[]) =>
  ids.map(
    (id) =>
      OUTREACH_DECLINE_REASONS.find((reason) => reason.id === id)?.title ?? id,
  );
